// 팀 상세 그래프의 선 목록을 만든다. 선택한 팀의 선(진하게) 아래에 우리 팀의 선(연하게, faded)을 깔아 비교할 수 있게 한다.
// curveOf(view) → { points }, colors[i]는 팀원 i의 선 색(두 팀 모두 같은 순서의 색을 쓴다).
export function buildCurveSeries({ views, referenceViews = null, curveOf, colors }) {
  const toSeries = (list, prefix, faded) => list.map((view, i) => ({
    key: `${prefix}-${view.characterName}-${i}`,
    color: colors[i % colors.length],
    points: curveOf(view).points,
    icon: `/img/character/${view.characterName}.png`,
    name: view.characterName,
    faded,
  }));
  return [
    ...(referenceViews ? toSeries(referenceViews, 'ref', true) : []),
    ...toSeries(views, 'team', false),
  ];
}
